import React from "react";

import {VIDEO_EXPORT_FORMAT_LIST, type VideoExportFormatId} from "libs/videoExportFormats";

export function VideoFormatSelect({
  value,
  onChange,
}: {
  value: VideoExportFormatId;
  onChange: (value: VideoExportFormatId) => void;
}) {
  return (
    <>
      <label htmlFor="video-format">Format:</label>
      <select
        className="video-format"
        id="video-format"
        value={value}
        onChange={(event) => onChange(event.target.value as VideoExportFormatId)}
      >
        {VIDEO_EXPORT_FORMAT_LIST.map((format) => (
          <option key={format.id} value={format.id}>
            {format.label}
          </option>
        ))}
      </select>
    </>
  );
}
